module.exports = __webpack_public_path__ + "img/raytracer_and_scene.7ea1a6a1.png";